/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-08-23 13:58:19
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-08-27 15:12:07
 * @FilePath: \web\sznc_industry\src\router\routes\modules\szgx.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
export default [
{
  path: 'szgxarticleManage',
  name: {list:['数字供销','运营','文章管理','管理文章']},
  component: () => import('@/views/szgxArticle/articleManage.vue')
},
{
  path: 'szgxarticleAdd',
  name: {list:['数字供销','运营','文章管理','添加文章']},
  component: () => import('@/views/szgxArticle/articleAdd.vue')
},
{
  path: 'szgxarticleClassifi',
  name: {list:['数字供销','运营','文章管理','文章分类']},
  component: () => import('@/views/szgxArticle/articleClassifi.vue')
},
{
  path: 'szgxarticleExamM',
  name: {list:['数字供销','运营','文章审核','文章审核']},
  component: () => import('@/views/szgxArticle/articleExamM.vue')
},
{
  path: 'szgxarticleExam',
  name: {list:['数字供销','运营','文章审核','文章审核'],title:'文章审核'},
  component: () => import('@/views/szgxArticle/articleExam.vue')
},
{
  path: 'szgxarticlePz',
  name: {list:['数字供销','运营','文章审核','文章配置']},
  component: () => import('@/views/szgxArticle/articlePz.vue')
},
{
  path: 'szgxbasicConfig',
  name: {list:['数字供销','设置','基本设置','基础信息']},
  component: () => import('@/views/szgxSetup/basicConfig.vue')
},
{
  path: 'szgxlink',
  name: {list:['数字供销','设置','基本设置','友情链接']},
  component: () => import('@/views/szgxSetup/link.vue')
},
{
  path: 'szgxqualifications',
  name: {list:['数字供销','设置','基本设置','商务资质']},
  component: () => import('@/views/szgxSetup/qualifications.vue')
},
{
  path: 'szgxaboutUs',
  name: {list:['数字供销','设置','基本设置','关于我们']},
  component: () => import('@/views/szgxSetup/aboutUs.vue')
},
{
  path: 'szgxmoduleAdd',
  name: {list:['数字供销','设置','基本设置','关于我们']},
  component: () => import('@/views/szgxSetup/moduleEdit.vue')
},
{
  path: 'szgxmoduleEdit',
  name: {list:['数字供销','设置','基本设置','关于我们']},
  component: () => import('@/views/szgxSetup/moduleEdit.vue')
},
{
  path: 'szgxEnter',
  name: {list:['数字供销','设置','基本设置','系统入口']},
  component: () => import('@/views/szgxSetup/enter.vue')
},{
  path: 'szgxProduct',
  name: {list:['数字供销','商城','商品管理','商品管理']},
  component: () => import('@/views/szgx/productManage/productList.vue'),
},{
  path: 'szgxProductDetail',
  name: {list:['数字供销','商城','商品管理','商品管理','商品详情'],title:'商品详情'},
  component: () => import('@/views/szgx/productManage/productDetail.vue'),
},{
  path: 'szgxProductExamM',
  name: {list:['数字供销','商城','商品管理','豁免审核商家']},
  component: () => import('@/views/szgx/productManage/productExamM.vue'),
},
{
  path: 'tradeStatics',
  name: {list:['数字供销','统计','统计分析','交易总览']},
  component: () => import('@/views/szgx/statistics/tradeStatics.vue')
},
{
  path: 'pendTask',
  name:{title:'待办中心'},
  component: () => import('@/views/pendingTask/index.vue')
}
]